import { useEffect, useRef, useState } from 'react';

const values = [
  {
    num: '01',
    title: '会議は"場"ではなく"仕組み"',
    body: '会議室に集まることが目的ではありません。意思決定という「アウトプット」を生み出す仕組みとして設計することで、会議は組織の推進エンジンになります。',
    icon: 'ri-settings-3-line',
  },
  {
    num: '02',
    title: '意思決定プロセスを設計する',
    body: '会議設計図・アジェンダ・決定基準・決定者——これらを事前に設計することで、参加者は会議に「参加」するのではなく「決断」のために召集されていきます。',
    icon: 'ri-flow-chart',
  },
  {
    num: '03',
    title: 'AIで実行を自動化する',
    body: '決定事項の議事録、タスクの割り振り、期限管理——AIを組み込むことで、人の手を介さず会議の結果が即座に「アクション」へ転換されます。',
    icon: 'ri-robot-2-line',
  },
];

export default function SolutionSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.08 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} id="solution" className="py-24 px-4 md:px-10 bg-white">
      <div className="max-w-5xl mx-auto">
        <div
          className="text-center mb-14 transition-all duration-700"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(20px)' }}
        >
          <span
            className="inline-block px-3 py-1 text-xs font-bold tracking-widest uppercase text-[#C0392B] border border-[#C0392B]/30 rounded-full mb-4"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            Solution
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight"
            style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
          >
            私たちが提供する<br />3つの価値
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {values.map((v, i) => (
            <div
              key={i}
              className="relative p-8 rounded-lg border border-gray-200 overflow-hidden transition-all duration-700 hover:border-[#C0392B]/30 hover:-translate-y-1"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(28px)',
                transitionDelay: `${i * 0.12}s`,
              }}
            >
              <div
                className="text-5xl font-bold text-gray-100 absolute top-4 right-5 select-none pointer-events-none"
                style={{ fontFamily: 'Poppins, sans-serif' }}
              >
                {v.num}
              </div>
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-[#C0392B]/10 mb-5">
                <i className={`${v.icon} text-xl text-[#C0392B]`} />
              </div>
              <h3
                className="text-base font-bold text-gray-900 mb-3 leading-snug"
                style={{ fontFamily: 'Noto Sans JP, sans-serif' }}
              >
                {v.title}
              </h3>
              <p className="text-sm text-gray-500 leading-relaxed" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                {v.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
